require("-!/opt/atlassian/pipelines/agent/build/node_modules/extract-text-webpack-plugin/loader.js?{\"omit\":1,\"extract\":true,\"remove\":true}!style!css?sourceMap!sass?sourceMap!/opt/atlassian/pipelines/agent/build/node_modules/font-awesome-loader/font-awesome-styles.loader.js!/opt/atlassian/pipelines/agent/build/font-awesome.config.js");


//////////////////
// WEBPACK FOOTER
// ../~/font-awesome-loader/index.loader.js!../font-awesome.config.js
// module id = 513
// module chunks = 1